import { getDataMapper, mapField } from "@/shared";

export const mapTranslationsFiltersToServer = getDataMapper({
    lang: mapField("lang"),
    namespace: mapField("namespace"),
});
